import { metricKeys } from '@pulse/metrics';
import { getPercentageLocalMetricName } from '../metrics/utilities';

const IMPACTED_ATTEMPTS_NAME = 'Impacted Attempts';
const AD_IMPACTED_ATTEMPTS_NAME = 'Ad Impacted Attempts';
const PCT_ATTEMPTS = '% Attempts';
const PCT_AD_ATTEMPTS = '% Ad Attempts';

const IMPACTED_PLAYS = 'Impacted Ended Plays';
const AD_IMPACTED_PLAYS = 'Ad Impacted Ended Plays';
const PCT_ENDED_PLAYS = '% Ended Plays';
const PCT_AD_ENDED_PLAYS = '% Ad Ended Plays';

export const ERROR_CODE_NAME = 'Error Code';
const BUSINESS_ERROR_CODE_NAME = 'Business Error Code';
const TECHNICAL_ERROR_CODE_NAME = 'Technical Error Code';

const ERROR_CODE_VSF = 'VSF_ERROR';
const ERROR_CODE_VPF = 'VPF_ERROR';
const ERROR_CODE_AWE = 'AD_ERROR';
const ERROR_CODE_VSFB = 'VSF_BUSINESS_ERROR';
const ERROR_CODE_VSFT = 'VSF_TECH_ERROR';
const ERROR_CODE_VPFB = 'VPF_BUSINESS_ERROR';
const ERROR_CODE_VPFT = 'VPF_TECH_ERROR';
const ERROR_CODE_AVSF = 'ASF_ERROR';
const ERROR_CODE_AVPF = 'APF_ERROR';

export const ERROR_METRIC_MAP = {
  [metricKeys.VideoStartFailures]: ERROR_CODE_VSF,
  [metricKeys.VideoPlaybackFailures]: ERROR_CODE_VPF,
  [metricKeys.VideoStartFailuresBusiness]: ERROR_CODE_VSFB,
  [metricKeys.VideoStartFailuresTech]: ERROR_CODE_VSFT,
  [metricKeys.VideoPlaybackFailuresBusiness]: ERROR_CODE_VPFB,
  [metricKeys.VideoPlaybackFailuresTech]: ERROR_CODE_VPFT,
  [metricKeys.VideoPlaybackFailuresTechPer1000PlayingMinutes]: ERROR_CODE_VPFT,
  [metricKeys.AdsWithErrors]: ERROR_CODE_AWE,
  [metricKeys.AdVideoStartFailures]: ERROR_CODE_AVSF,
  [metricKeys.AdVideoPlaybackFailures]: ERROR_CODE_AVPF,
};
// Adding a new param queryMetric for CSR-6273
export const ERROR_DIMENSION_MAP = {
  [ERROR_CODE_VSF]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: metricKeys.Attempts,
    primary: metricKeys.VideoStartFailures,
    queryMetric: metricKeys.Attempts,
    dimension: ERROR_CODE_VSF,
    header: ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.Attempts),
  },
  [ERROR_CODE_VSFB]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: metricKeys.Attempts,
    primary: metricKeys.VideoStartFailuresBusiness,
    queryMetric: metricKeys.Attempts,
    dimension: ERROR_CODE_VSFB,
    header: BUSINESS_ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.Attempts),
  },
  [ERROR_CODE_VSFT]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: metricKeys.Attempts,
    primary: metricKeys.VideoStartFailuresTech,
    queryMetric: metricKeys.Attempts,
    dimension: ERROR_CODE_VSFT,
    header: TECHNICAL_ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.Attempts),
  },
  [ERROR_CODE_VPF]: {
    columnName: IMPACTED_PLAYS,
    pctColumnName: PCT_ENDED_PLAYS,
    baseline: metricKeys.EndedPlays,
    primary: metricKeys.VideoPlaybackFailures,
    queryMetric: metricKeys.VideoPlaybackFailures,
    dimension: ERROR_CODE_VPF,
    header: ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.EndedPlays),
  },
  [ERROR_CODE_VPFB]: {
    columnName: IMPACTED_PLAYS,
    pctColumnName: PCT_ENDED_PLAYS,
    baseline: metricKeys.EndedPlays,
    primary: metricKeys.VideoPlaybackFailuresBusiness,
    queryMetric: metricKeys.VideoPlaybackFailuresBusiness,
    dimension: ERROR_CODE_VPFB,
    header: BUSINESS_ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.EndedPlays),
  },
  [ERROR_CODE_VPFT]: {
    columnName: IMPACTED_PLAYS,
    pctColumnName: PCT_ENDED_PLAYS,
    baseline: metricKeys.EndedPlays,
    primary: metricKeys.VideoPlaybackFailuresTech,
    queryMetric: metricKeys.VideoPlaybackFailuresTech,
    dimension: ERROR_CODE_VPFT,
    header: TECHNICAL_ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.EndedPlays),
  },
  [ERROR_CODE_AWE]: {
    columnName: IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_ATTEMPTS,
    baseline: metricKeys.Attempts,
    primary: metricKeys.AdsWithErrors,
    queryMetric: metricKeys.Attempts,
    dimension: ERROR_CODE_AWE,
    header: ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.Attempts),
  },
  [ERROR_CODE_AVSF]: {
    columnName: AD_IMPACTED_ATTEMPTS_NAME,
    pctColumnName: PCT_AD_ATTEMPTS,
    baseline: metricKeys.AdAttempts,
    primary: metricKeys.AdVideoStartFailures,
    queryMetric: metricKeys.AdAttempts,
    dimension: ERROR_CODE_AVSF,
    header: ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.AdAttempts),
  },
  [ERROR_CODE_AVPF]: {
    columnName: AD_IMPACTED_PLAYS,
    pctColumnName: PCT_AD_ENDED_PLAYS,
    baseline: metricKeys.AdEndedPlays,
    primary: metricKeys.AdVideoPlaybackFailures,
    queryMetric: metricKeys.AdVideoPlaybackFailures,
    dimension: ERROR_CODE_AVPF,
    header: ERROR_CODE_NAME,
    pctMetricKey: getPercentageLocalMetricName(metricKeys.AdEndedPlays),
  },
};

export const isErrorCodeByDimension = (dimension) => dimension in ERROR_DIMENSION_MAP;
export const isErrorCodeByMetric = (metric) => metric in ERROR_METRIC_MAP;
export const getErrorCodeDimension = (metric) => ERROR_METRIC_MAP[metric];

export const getErrorMetricInfo = (metric) => {
  const dimension = getErrorCodeDimension(metric);
  return ERROR_DIMENSION_MAP[dimension] || {};
};
export const getErrorDimensionInfo = (dimension) => ERROR_DIMENSION_MAP[dimension] || {};

export const findErrorCodeMetric = (metrics) => metrics.find(isErrorCodeByMetric);
